import Service from '../service.js';

export default {
  components: {
  },
  data() {
    return {
      queryParams: {},
      details: {
        areaInfo: {}
      }
    };
  },
  created() {
    this.queryParams = this.$route.query;
    this.getDetails();
  },

  methods: {
    getDetails() {
      Service.getOrderDetails({id: this.queryParams.id}).then(res => {
        this.details = res;
      });
    },
    back() {
      this.$router.back();
    }
  }
};
